import Vue from 'vue';
import axios from 'axios'
import Qs from 'qs'
import router from '@/router/index'
import store from '@/store/index'
import { Message } from 'element-ui'
import md5 from 'js-md5'

let obj2url = function(obj) {
	var exportUrl = "";
	Object.keys(obj).map((key) => {
		exportUrl += key + '=' + obj[key] + '&';
	})
	return exportUrl
}



// 获取签名sign==================================
let signfun = (data,token)=>{
    let key = "538ca1021bccd25eb9d06f98aad10c32"
    data.timestamp = Date.parse(new Date());
    data.token = token;
    let sign = obj2url(data) + "key=" + key;
    // console.log(sign)
    sign = md5(sign);
    sign = sign.toUpperCase();
    return sign
}
// end ================================

const toLogin = () => {
    //store.dispatch('user/logout')
    // router.push({
    //     path: '/login',
    // })
	store.commit("logout")
	router.push({
	    path: '/index',
	})
	store.commit("openlogin")
	Message.error("登录已过期，请重新登录")

}

const api = axios.create({
    baseURL: process.env.VUE_APP_API_ROOT,
    timeout: 10000,
    responseType: 'json'
    // withCredentials: true
})

api.interceptors.request.use(
    request => {
        if (request.method == 'post') {
            if (request.data instanceof FormData) {
                if (store.state.token) {
                    // 如果是 FormData 类型（上传图片）
                    request.headers["Authorization"]="Bearer "+store.state.token
                    // request.data.append('token', store.state.user.token)
                }
            } else {
                // 带上 token
                if (request.data == undefined) {
                    request.data = {}
                }
                if (store.state.token) {

                    request.headers["Authorization"]="Bearer "+store.state.token
                }
                // request.data.sign = "2BF1D796CB729A43AAFB940DF857970C";
                // request.data.timestamp = "12312312313";
                request.data = Qs.stringify(request.data);
            }
        } else {
            // 带上 token
            if (request.params == undefined) {
                request.params = {}
            }
            if (store.state.token) {
                request.headers["Authorization"]="Bearer "+store.state.token
                // request.params.token = store.state.user.token
            }
            // request.params.sign = "2BF1D796CB729A43AAFB940DF857970C";
            // request.params.timestamp = "12312312313";
        }

        return request
    }
)

api.interceptors.response.use(
    // response => {
    //     let res =  response.data
    //     console.log(res)
    //     if (res.code == 1000) {
    //         return Promise.resolve(res)
    //     }
    //     else if (res.code ==500){
    //         toLogin()
    //         Message.error(res.message)
    //         return Promise.reject(res.code)

    //     }
    //     else{
    //         Message.error(res.message)
    //         return Promise.reject(res.code)

    //     }
    // },

    //修改 2011/11/11
    response => {
        let res = response.data
        if (res.code==200){
            if (res.data){
                let resData =  response.data
                return Promise.resolve(resData)
            }else{
                Message.error("数据格式错误")
                return Promise.reject('后台接口错误');
            }

        }
        if (res.code==20001){
            if (res.data){
                let resData =  response.data
                return Promise.resolve(resData)
            }else{
                Message.error("数据格式错误")
                return Promise.reject('后台接口错误');
            }

        }
        else if (res.code==401){

            toLogin()
            Message.error(res.message)
            return Promise.reject(res)
        }
        // else if (res.code==10101){
        //     const errdata = res.data;
        //     let html = ``;
        //     for (let i in errdata) {
        //         html = html + `<p>${errdata[i]}</p>`;
        //     }
        //     Vue.prototype.$message({
        //         showClose: true,
        //         message: html,
        //         type: 'error',
        //         dangerouslyUseHTMLString: true
        //     });

        //     return Promise.reject(res)
        // }
        else if(res.code==1111){
            return Promise.reject(res)
        }
        else{
            Message.error(res.message)
            return Promise.reject(res)
        }
    },


    error => {
        return Promise.reject(error)
    }
)

export default api
